import { useGetLabelsQuery } from 'features/metadata/metadata';
import { useActiveOrganisation } from 'hooks/useActiveOrganisation';
import { useGetOrganisationTags } from 'hooks/useGetOrganisationTags';
import { useMemo } from 'react';
import { CircleFill } from 'react-bootstrap-icons';

import HelperFunctions from '../../../../pages/global/HelperFunctions';
import TagHelper from '../../../../pages/global/TagHelper';

const emptyArray = [];

export function TagColor({ comments }) {
    const activeOrganisation = useActiveOrganisation();
    const organisationTags = useGetOrganisationTags();

    const { commentLabels = emptyArray, availableTags = emptyArray } = useGetLabelsQuery(
        { organisationId: activeOrganisation },
        {
            selectFromResult: ({ data }) => ({
                commentLabels: data ?? emptyArray,
                availableTags: organisationTags,
            }),
        },
    );

    const colorComponents = useMemo(() => {
        const uniqueColors = new Set();

        return comments.reduce((accumulator, comment) => {
            const commentTags = comment.tags;

            if (commentTags.length > 0) {
                commentTags.forEach((tagData) => {
                    let tag;

                    if (tagData.hasOwnProperty('uri')) {
                        tag = HelperFunctions.getByValue(commentLabels, '@id', tagData.uri);
                    } else {
                        // Old style
                        tag = HelperFunctions.getByValue(availableTags, 'id', tagData.id);
                    }

                    if (tag !== undefined) {
                        const color = TagHelper.getTagColor(tag);

                        if (color !== 'default' && !uniqueColors.has(color)) {
                            uniqueColors.add(color);
                            accumulator.push(
                                <CircleFill
                                    key={color}
                                    size={7}
                                    style={{ marginRight: '2px', width: 7, height: 7 }}
                                    className={`flex-shrink-0 tag-icon-${color}`}
                                />,
                            );
                        }
                    }
                });
            }

            return accumulator;
        }, []);
    }, [comments, commentLabels, availableTags]);

    if (colorComponents.length === 0) {
        return null;
    }

    return (
        <div
            className="position-absolute d-flex"
            style={{
                top: 2,
                left: 20,
            }}
        >
            {colorComponents}
        </div>
    );
}
